<script>
export default {
  name: "PrintCombineInvoice",

  data() {
    return {
      patient: {},
      invoiceinfo:{},
      invoiceLines: {
        combinedPaymentnInvoiceItemsDetails: [],
        combinedPaymentnInvoiceDetails: [],
        visitNo:'',
      },
      visitDetail:[],
    age:0,
nationalId:0,  dateofAdmission:'',
dateofDischarge:'',
ward:'',
bed:'', 
    };
  },

  computed: {
    totalAmount() {
      if (!this.invoiceLines.combinedPaymentnInvoiceDetails.length) return 0;
      this.getPatientVisitDetails(this.invoiceLines.visitNo);
      return this.invoiceLines.combinedPaymentnInvoiceDetails
        .map((line) => parseFloat(line.amount))
        .reduce((sum, amount) => sum + amount);
    },
  },

  mounted() {
    this.$root.loading = true;
    Promise.all([ this.fetchPatient(), this.fetchCombinedPayments() ])
      .then(() => {
        this.$root.loading = false;
        setTimeout(() => {
          window.print();
        }, 250);
      })
      .catch(() => {
        this.$root.loading = false;
      });
  },

  methods: {
    fetchPatient() {
      let url = `PatientRegistration/GetSpecificPatient`;
      url += `?PatientID=${this.$route.query.patientID}`;

      return this.$http
        .get(url)
        .then((response) => {
          this.patient = response.data.length ? response.data[0] : {};

          return Promise.resolve();
        })
        .catch(() => { return Promise.reject(); });
    },

    fetchCombinedPayments() {
      const url = `Accounts/GetCombinedPaymentsnInvoicesDetails`;

      return this.$http
        .get(`${url}?ReceiptnInvoiceNo=${this.$route.query.invoiceNo}`)
        .then((response) => {
          this.invoiceLines = response.data;
          if(this.invoiceLines.combinedPaymentnInvoices.length>0)
          {
            this.invoiceinfo=this.invoiceLines.combinedPaymentnInvoices[0];
          }
          else
          {
            this.invoiceinfo={};
          }

          return Promise.resolve();
        })
        .catch(() => { return Promise.reject(); });
    },
    getPatientVisitDetails(visitNo) {
      let url = `Visits/GetSpecificPatientVisit`;

      return this.$http
        .get(`${url}?VisitId=${visitNo}`)
        .then((response) => {
          this.visitDetail = response.data;
          this.age= this.visitDetail.specificVisitRecord.age;
       this.nationalId= this.visitDetail.specificVisitRecord.nationalid;
     //  this.dateofAdmission= this.visitDetail.specificVisitRecord.admissionDate;
//this.dateofDischarge= this.visitDetail.specificVisitRecord.disschargeDate;

this.dateofAdmission= this.invoiceinfo.invoicingAdmissionDate||this.visitDetail.specificVisitRecord.admissionDate;
this.dateofDischarge= this.invoiceinfo.invoicingDischargeDate||this.visitDetail.specificVisitRecord.disschargeDate;
this.ward= this.visitDetail.specificVisitRecord.ward;
this.bed= this.visitDetail.specificVisitRecord.bed;
        })
        .catch(() => {this.visitDetail=[]});
    },
  },
};
</script>
<template>
  <div class="w-full flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full p-1 text-center my-3">
      <h5 class="font-medium text-base uppercase">INVOICE FOR TREATMENT</h5> 
    </div>
  <tail-stamp></tail-stamp>
    <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5> 
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
      </div>
      <!-- <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Visit No: {{ patient.visitNo }}</h5>
      </div> -->
      <div class="w-full my-1">
        <h5 class="font-medium text-xs">P Mode: {{ patient.pMode }}</h5>
      </div>
    </div>
    <div class="w-full text-center my-1">
      <h5 class="font-bold text-base uppercase">
        Invoice No: {{ $route.query.invoiceNo }}
      </h5>
    </div>
    <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Ward: 
               <span class="text-blue-800">{{ ward || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Bed: 
               <span class="text-blue-800">{{bed|| `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Admitted : 
               <span class="text-blue-800">{{ dateofAdmission|dateFormat }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Discharged : 
               <span class="text-blue-800">{{dateofDischarge|dateFormat}}</span></h6>
            </div>
            </div>
     
            <!-- <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
                <h6 class="w-full font-bold text-center">Patient  </h6>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left  pl-2">Name: 
               <span class="text-blue-800">{{ patient.names }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">OP File No: 
               <span class="text-blue-800">{{  patient.ipfileno || `-` }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">IP File No: 
               <span class="text-blue-800">{{ patient.opfileno || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Age: 
               <span class="text-blue-800">{{ patient.age || `-` }} Yr(s)</span></h6>
            </div>
            
        </div>  -->
        
        <!-- <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">ID No: 
               <span class="text-blue-800">{{ patient.nationalid|| `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Member No: 
               <span class="text-blue-800">{{ patient || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Dependant : 
               <span class="text-blue-800">{{ patient.opfileno || `-` }}</span></h6>
            </div>
            </div> -->
    <table class="table">
      <thead class="text-sm">
        <tr class="w-full flex">
          <th class="p-tiny flex-1">Date</th>
           <th class="p-tiny w-1/2">Item</th>
          <th class="p-tiny flex-1">Bill No</th>
          <th class="p-tiny flex-1">Qty</th>
          <th class="p-tiny flex-1">Amount</th>
          <th class="p-tiny flex-1">Total</th>
        </tr>
      </thead>
      <tbody class="text-xs flex flex-col items-center">
        <tr
          class="w-full flex"
          v-for="(line,
          idx) in invoiceLines.combinedPaymentnInvoiceItemsDetails"
          :key="idx"
        >
        <td class="p-tiny flex-1">{{ line.txnDate|dateFormat }}</td>
        <td class="p-tiny w-1/2">{{ line.service }}</td>
          <td class="p-tiny flex-1">{{ line.billNo }}</td>
          <td class="p-tiny flex-1">{{ line.quantity }}</td>
          <td class="p-tiny flex-1">{{ line.charge | numberFormat }}</td>
          <td class="p-tiny flex-1">{{ line.grandTotal | numberFormat }}</td>
        </tr>
        <tr
          class="w-full flex"
          v-for="(detail) in invoiceLines.combinedPaymentnInvoiceDetails"
          :key="`${detail.combinedDetailID}__`"
        >
          <th colspan="5" class="p-tiny flex-1 text-right">
            {{ detail.organization || '-' }}: {{ detail.amount | numberFormat }}
          </th>
        </tr>
        <tr class="w-full flex">
          <th colspan="5" class="p-tiny flex-1 text-right uppercase">
            Total: {{ totalAmount | numberFormat }}
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>
